<router-outlet></router-outlet>
<app-spinner></app-spinner>
<app-snackbar></app-snackbar>